import React, { Component } from 'react';
import classNames from 'classnames';
import { Icon } from 'ui';
import Menu from './Menu';

/* eslint no-mixed-operators: 0 */

class AdjacentAction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      menuStyle: {},
    };
    this.showMenu = this.showMenu.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
    this.handleItemClick = this.handleItemClick.bind(this);
    this.setRef = this.setRef.bind(this);
  }

  handleItemClick(...args) {
    this.setState({ active: false }, () => {
      this.props.onActionClick(...args);
      this.closeMenu(null, true);
    });
  }

  showMenu(e) {
    e.persist(); // disable event pooling
    if (!this.state.active) {
      this.setState({ active: true }, () => {
        this.updateMenuPosition(e);
        window.addEventListener('click', this.closeMenu);
      });
    } else if (e.target !== this.menu.refs.menu) {
      this.updateMenuPosition(e);
    }
  }

  closeMenu(evt, forceClose) {
    if (forceClose || !this.container.contains(evt.target))
      this.setState({ active: false }, () => {
        this.resetPosition();
        window.removeEventListener('click', this.closeMenu);
      });
  }

  updateMenuPosition({ clientX, clientY }) {
    const { menu } = this.menu.refs;
    const containerRect = this.container.getBoundingClientRect();
    const [xShift, yShift] = [30, 10];

    const newPosition = {};
    newPosition.top = clientY - containerRect.top + yShift;
    newPosition.right = Math.max(
      0,
      containerRect.right - clientX - menu.offsetWidth + xShift,
    );

    if (window.innerWidth < 1335 && newPosition.right === 0) {
      newPosition.right += 110;
      newPosition.top = 10;
    }

    if (
      window.innerHeight - clientY < menu.offsetHeight &&
      clientY > menu.offsetHeight
    ) {
      newPosition.bottom = containerRect.bottom - clientY - yShift;
      delete newPosition.top;
    }

    this.setMenuPosition(newPosition);
  }

  setMenuPosition({ top, right, bottom }) {
    this.setState({
      menuStyle: {
        top: top && `${top}px`,
        right: right && `${right}px`,
        bottom: bottom && `${bottom}px`,
      },
    });
  }

  resetPosition() {
    this.setState({ menuStyle: null });
  }

  setRef(ref, key) {
    this[key] = ref;
  }

  render() {
    const containerClassName = classNames('AdjacentAction', {
      'is-active': this.props.active || this.state.active,
    });

    return (
      <div
        className={containerClassName}
        onClick={this.showMenu}
        onKeyDown={e => e.key === 'Enter' && this.showMenu()}
        ref={node => node && this.setRef(node, 'container')}
      >
        <div className="AdjacentAction-rule" />
        <div className="AdjacentAction-label">
          <div className="AdjacentAction-labelText">{this.props.label}</div>
          <div className="AdjacentAction-icon">
            <Icon name={this.props.icon} stabilize={false} />
          </div>
        </div>
        <Menu
          onItemClick={this.handleItemClick}
          options={this.props.options}
          setRef={this.setRef}
          style={this.state.menuStyle}
          visible={this.state.active}
        />
      </div>
    );
  }
}

export default AdjacentAction;
